import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Permissions & History Development Plan (13.10.2026) — the full Case
// Control queue is still manage_case_control-only; anyone without it
// never had access to its data (the API already enforces that), this just
// keeps the URL from landing them on a page that will come back empty.
const RequireCaseControl = ({ children }) => {
  const { permissions } = useAuth();
  if (permissions && !permissions.manage_case_control) {
    return <Navigate to="/case-control/current" replace />;
  }
  return children;
};

export default RequireCaseControl;
